module.exports = {
    LIGHT_THEME: "light",
    DARK_THEME: "dark"
};
